<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4 col-md-offset-4">
        <header class="login-pf-page-header">
          <img src="../../../static/logo.png" class="img-fluid login-pf-brand" width="0" alt="">
          <h1 class="title">OSDA Event Management System</h1>
        </header>
        <div class="row">
          <div class="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
            <div class="card-pf">
              <header class="login-pf-header">
                <h1>กรุณาเข้าสู่ระบบ</h1>
                <div v-if="error" class="alert alert-danger">
                  <span class="pficon pficon-error-circle-o" />
                  <strong>พบข้อผิดพลาด</strong> โปรดตรวจสอบชื่อผู้ใช้และรหัสผ่านใหม่อีกครั้ง
                </div>
              </header>
              <form>
                <div class="form-group">
                  <label class="sr-only">ชื่อผู้ใช้งาน</label>
                  <input v-model="username" type="text" class="form-control input-lg" placeholder="ชื่อผู้ใช้งาน">
                </div>
                <div class="form-group">
                  <label class="sr-only">รหัสผ่าน
                  </label>
                  <input v-model="password" type="password" class="form-control input-lg" placeholder="รหัสผ่าน">
                </div>
                <button class="btn btn-primary btn-block btn-lg" @click.prevent="login">เข้าสู่ระบบ</button>
              </form>
            </div><!-- card -->
          </div><!-- col -->
        </div><!-- row -->
      </div><!-- col -->
    </div><!-- row -->
  </div><!-- container -->
</template>

<script>
export default {
  data () {
    return {
      username: '',
      password: '',
      error: false
    }
  },
  methods: {
    login () {
      this.$auth.login({
        data: { username: this.username, password: this.password },
        rememberMe: true
      }).then(() => {
        this.error = false
      }).catch(_ => {
        this.error = 'ss'
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .card-pf {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  h1 {
    margin-top: 0;
  }

  .container-fluid {
    text-align: center;
    min-height: 100vh;
    padding-top: 50px;
    background: url(../../../static/login-bg2.jpg);
    background-size: cover;
  }

  h1.title {
    color: #fff;
    margin-bottom: 20px;
  }

  .login-pf-brand {
    filter: brightness(100);
    margin-bottom: 20px;
  }

  .login-pf-header h1 {
    margin-bottom: 30px;
  }

  .alert {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/js/views/Login.vue